import { PlexRoute, Routes } from '@all-hands-hq/plex-graphql-schema';
import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

type RouterHistoryMode = 'push' | 'replace';
export type Value = PlexRoute;
export type Setter = (v: Partial<Value>, mode?: RouterHistoryMode) => void;

export function usePlexRoute(): [Value, Setter] {
  const history = useHistory();

  const plexRoute = useMemo(
    () => Routes.urlToRoute({ pathname: history.location.pathname, search: history.location.search }),
    [history.location.pathname, history.location.search]
  );

  const updatePlexRoute = useCallback(
    (plexRouteDelta: Partial<Value>, mode: RouterHistoryMode = 'push'): void => {
      const set = history[mode];

      const currentRoute = Routes.urlToRoute(history.location);
      const { pathname, search } = Routes.routeToUrlComponents({
        route: {
          ...currentRoute,
          ...plexRouteDelta,
        },
        search: history.location.search,
      });

      set({
        ...history.location,
        pathname,
        search,
      });
    },
    [history]
  );

  return [plexRoute, updatePlexRoute];
}
